import {openResourceModal} from '../../core/modalCommand';
import {
	ROLE_CREATE_MODAL_EVENT,
	ROLE_DELETE_MODAL_EVENT,
	ROLE_EDIT_MODAL_EVENT,
} from './events';

/**
 * Open Edit Role for the resolved row.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openRoleEditModal(command, envelope) {
	return openResourceModal(ROLE_EDIT_MODAL_EVENT, command, envelope);
}

/**
 * Open the Delete Role confirmation - the confirmation, not the deletion.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openRoleDeleteModal(command, envelope) {
	return openResourceModal(ROLE_DELETE_MODAL_EVENT, command, envelope);
}

/**
 * Open Add Role - the empty form, with nothing filled in.
 *
 * The Add forms are deliberately not mapped field by field, so the agent
 * opens the form and the person fills it.
 *
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openRoleCreateModal(command, envelope) {
	return openResourceModal(ROLE_CREATE_MODAL_EVENT, command, envelope);
}
